import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_GROUP_LIST_ENDPOINT,
  CREATE_GROUP_ENDPOINT,
  UPDATE_GROUP_ENDPOINT,
  DELETE_GROUP_ENDPOINT,
  GET_PATIENT_FIELD_ENDPOINT,
  GET_SINGLE_GROUP_ENDPOINT,
  GROUP_ORDER_DATE,
} from "./endpoints";

//Get Group List
export const getGroupListAPI = (payload) => {
  return API.post(GET_GROUP_LIST_ENDPOINT, payload);
};

//Create Group
export const createGroupAPI = (payload) => {
  return API.post(CREATE_GROUP_ENDPOINT, payload);
};

//Update Group
export const updateGroupAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_GROUP_ENDPOINT, { group_id: id }),
    payload
  );
};

//Single Group Data
export const getSingleGroup = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_GROUP_ENDPOINT, { group_id: id })
  );
};

//Delete Group
export const deleteSurGroupAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_GROUP_ENDPOINT, { group_id: id })
  );
};

//Patient List
export const getPatientListAPI = (payload) => {
  return API.post(GET_PATIENT_FIELD_ENDPOINT, payload);
};

//Single Group Data
export const updateOrderDateGroupAPI = (id, payload) => {
  return API.post(
    generateDynamicEndpoint(GROUP_ORDER_DATE, { id: id }),
    payload
  );
};
